import { ReactNode } from 'react';
import InfiniteScrollExternal from 'react-infinite-scroll-component';

import { cx } from '@libs/classnames';
import { Loader } from '@ui/components/Loader';

import styles from './InfiniteScroll.module.css';

export type Props = {
  className?: string;
  scrollableClassName?: string;
  fetchMore: () => void;
  hasMore: boolean;
  itemsLength: number;
  hideLoader?: boolean;
  children: ReactNode;
};

export function InfiniteScroll({
  className,
  scrollableClassName,
  fetchMore,
  itemsLength,
  hasMore,
  hideLoader,
  children,
}: Props) {
  return (
    <div className={cx(className, styles.root)}>
      <InfiniteScrollExternal
        className={scrollableClassName}
        next={fetchMore}
        hasMore={hasMore}
        loader={hideLoader ? undefined : <Loader className={styles.loader} centered />}
        dataLength={itemsLength}
        height="auto"
      >
        {children}
      </InfiniteScrollExternal>
    </div>
  );
}
